import Vue from 'vue'
// import { firebaseMutations, firebaseAction } from 'vuexfire'
import u from '@/util'
import {
  t
} from '@/i18n'
import data from '@/data'
// const ref = data.db.ref('/meetings')

const state = {
  assignments: [],
  cell: '',
  dates: [],
  index: -1,
  date: null,
  edit: false,
  content: '',
  attendance: {},
  dirty: false,
  valid: true
}

const getters = {
  dates: state => state.dates,
  attendance: (state) =>
    Object.keys(state.attendance)
      .map(person => ({
        person,
        role: state.attendance[person],
        present: true
      }))
      .concat(state.assignments.filter(it => !Object.keys(state.attendance).includes(it.person)))
      .sort(u.comparator('person')),
  nextDate: state => {
    const {
      dates,
      index
    } = state
    return index > -1 && index < dates.length - 1 && dates[index + 1]
  },
  prevDate: state => {
    const {
      dates,
      index
    } = state
    const i = index === -1 ? dates.length : index
    return i > 0 && dates[i - 1]
  },
  lastDate: state => state.dates[state.dates.length - 1] || '',
  isNew: state => state.index === -1,
  validations: state => ({
    date: [
      v => !!v || t('Date incorrect'),
      v => !v || state.index !== -1 || !state.dates.includes(v) ||
        t('Meeting date already exists', state.date, false),
      v => !v || v > '2020-06-30' || 'Data musi być poźniejsza niż 30 czerwca 2020'
    ]
  }),

  // Meeting statistics
  members: (state, g) => g.attendance.filter(_ => _.role !== 'G' && _.role !== 'V'),
  memberCount: (state, g) => g.members.length,
  presentMemberCount: (state, g) => g.members.filter(_ => _.present).length,
  presentCount: (state, g) => g.attendance.filter(_ => _.present).length,
  presentCountG: (state, g) => g.attendance.filter(_ => _.present).filter(_ => _.role === 'G').length,
  presentCountV: (state, g) => g.attendance.filter(_ => _.present).filter(_ => _.role === 'V').length,
  percent: (state, g) => g.memberCount ?
    (g.presentMemberCount / g.memberCount * 100).toFixed() : 0
}

const mutations = { // firebaseMutations
  attendance(state, {
    person,
    value
  }) {
    if (value) {
      const assignment = state.assignments.find(it => it.person === person)
      Vue.set(state.attendance, person, assignment ? assignment.role : 'G')
    } else {
      Vue.delete(state.attendance, person)
    }
    state.dirty = true
  },
  dates(state, {
    cell,
    dates,
    index
  }) {
    state.cell = cell
    state.dates = dates
    mutations.index(state, index !== undefined ? index : dates.length - 1)
  },
  edit(state, payload) {
    state.edit = payload
  },
  index(state, value) {
    // state.dirty = value === -1
    state.index = value
    state.date = state.dates[state.index] ||
      state.dates.length && u.dateAdd(state.dates[state.dates.length - 1], 7) || u.today()
  },
  date(state, value) {
    state.date = value
  },
  content(state, value) {
    state.content = value
  },
  dirty(state, value) {
    state.dirty = value
  },
  valid(state, value) {
    state.valid = value
  },
  setMeeting(state, {
    attendance,
    content
  }) {
    state.attendance = attendance || {}
    state.content = content
    state.present = {}
    // state.dirty = true
  },
}

const actions = {
  bindAssignments: data.assignments2.bindAssignment('assignments'),
  unbindAssignments: data.assignments2.unbindAssignment('assignments'),

  addPerson(context, item) {
    const found = context.state.assignments.find(it => it.person === item.person)
    if (found) {
      context.commit('error', t('Person #{param} enlisted already', item.person), {
        root: true
      })
    } else {
      return data.assignments2.add(item)
    }
  },

  dates(context, cell) {
    return data.meetings2.findDates(cell).then(d => {
      const dates = d || []
      context.commit('dates', {
        cell,
        dates
      })
      context.dispatch('meeting')
      return dates
    })
  },

  meeting(context, index) {
    if (index !== undefined) {
      context.commit('index', index)
    }
    const cell = context.state.cell
    // console.log(cell, context.state.date)
    return data.meetings2.findByCellDate(cell, context.state.date).then(m => {
      const meeting = m || {
        attendance: {},
        content: ''
      }
      context.commit('setMeeting', meeting)
      return meeting
    })
  },

  async create(context) {
    if (context.rootGetters.readOnly) return
    // assumtion: 'meetings' action has been called beforehand to bind assignments
    if (await actions['pass dirty?'](context)) {
      const meeting = {
        attendance: {},
        content: ''
      }
      context.commit('index', -1)
      // context.commit('dirty', true)
      context.commit('setMeeting', meeting)
      return meeting
    }
  },

  async save(context, payload) {
    payload = payload || {}
    if (context.rootGetters.readOnly) return
    const valid = await context.dispatch('valid', {
      module: 'meeting2'
    }, {
      root: true
    })
    if (!valid) return
    const {
      cell,
      date,
      content,
      dates,
      index,
      attendance,
    } = context.state
    const memberCount = context.getters.memberCount

    let dateToRemove = null
    if (dates[index] !== date) { // Date modified or added
      const newDates = [...dates]
      if (dates[index]) {
        dateToRemove = dates[index]
        newDates.splice(index, 1)
      }
      if (newDates.includes(date)) {
        context.commit('error', t('Meeting date already exists', date), {
          root: true
        })
        return
      }
      if (Object.keys(attendance).length < 2) {
        context.commit('error', t('Meeting must have at least two person attended'), {
          root: true
        })
        return
      }
      newDates.push(date)
      newDates.sort()
      const newIndex = newDates.indexOf(date)
      context.commit('dates', {
        cell,
        dates: newDates,
        index: newIndex
      })
    }

    context.getters.attendance.forEach(it => {
      if (it.present) {
        context.commit('attendance', {
          person: it.person,
          value: true
        })
      }
    })
    const meeting = {
      attendance,
      content,
      memberCount
    }

    await data.meetings2.save(cell, context.state.dates, date, dateToRemove, meeting)
    context.commit('dirty', false)
    if (!payload.keepEditing) context.commit('edit', false)

    if (payload.send) {
      // Send emails
      const to = (await data.cells.findOne(context.rootGetters.cell) || {}).reportEmails
      if (to) {
        const {
          attendance,
          presentCount,
          presentMemberCount,
          memberCount,
          percent
        } = context.getters
        const cellDesc = context.rootGetters['cell/cellDesc'](cell)
        const mailOptions = {
          from: t('Email from'),
          to: to,
          cell,
          subject: t('Meeting email subject', { date, cellDesc }, false),
          html: `<p>Data: ${date}</p>` +
            `<p>${t('Persons count')}: ${presentCount}</p>` +
            `<p>${t('Attendance without guests')}: ${presentMemberCount}/${memberCount} = ${percent}%</p><table>` +
            attendance.map(a =>
              `<tr><td>${a.present ? '√&nbsp;' : ''}</td><td>${a.person}</td></tr>`).join('') +
            `</table><p>${t('Content')}: </br>${meeting.content.replace(/\n/g, '</br>')}</p>` +
            `<p>&nbsp;</p></br><p style="font-size: 10px"><i>${t('Email disclaimer')}</i></p>`
        }
        data.mailer.create(mailOptions)
      }
      context.commit('snackbar', t('Sent'), {
        root: true
      })
    } else {
      context.commit('snackbar', t('Saved'), {
        root: true
      })
    }
  },

  async send(context) {
    if (context.rootGetters.readOnly) return
    return context.dispatch('save', {
      send: true
    })
  },

  async remove(context) {
    if (context.rootGetters.readOnly) return
    const {
      cell,
      date,
      dates,
      index
    } = context.state
    // const limitDate = u.dateAdd(u.today(), -30)
    // if (date < limitDate) {
    //   context.commit('error', t('Cannot remove before date', limitDate), { root: true })
    //   return
    // }
    const params = {
      params: t('meeting with params', date)
    }
    if (await context.dispatch('confirmDelete', params, {
      root: true
    })) {
      const newDates = [...dates]
      const dateToRemove = dates[index]
      newDates.splice(index, 1)
      const payload = {
        cell,
        dates: newDates,
        index: Math.min(index, newDates.length - 1)
      }
      context.commit('dates', payload)
      context.dispatch('meeting', payload.index)
      await data.meetings2.save(cell, newDates, date, dateToRemove, null)
      context.commit('snackbar', t('Removed'), {
        root: true
      })
    }
  },

  async removePerson(context, item) {
    if (await context.dispatch('confirmDelete', {
      params: t('person #{param}', item.person)
    }, {
      root: true
    })) {
      data.assignments2.remove(item).then(() => {
        context.commit('snackbar', t('Removed'), {
          root: true
        })
      })
    }
  },

  async prev(context) {
    if (await actions['pass dirty?'](context)) {
      if (context.state.index === -1) {
        return context.dispatch('meeting', context.state.dates.length - 1)
      } else if (context.state.index > 0) {
        return context.dispatch('meeting', context.state.index - 1)
      }
    }
  },
  async next(context) {
    if (await actions['pass dirty?'](context)) {
      if (context.state.index < context.state.dates.length - 1 && context.state.index >= 0) {
        return context.dispatch('meeting', context.state.index + 1)
      }
    }
  },

  // // Returns [{ path, attendace }]
  // personAttendance (context, payload) {
  //   const { cell } = payload
  //   const promise = context.state.dates.length !== 0
  //     ? Promise.resolve(context.state.dates)
  //     : context.dispatch('meeting/dates', payload)
  //   return promise.then(dates =>
  //     Promise.all(dates.map(date => {
  //       const path = ref.child(cell).child(date).child('attendance')
  //       return path.once('value').then(s => ({ path, attendance: s.val() }))
  //     })).then(data => data.filter(_ => _.attendance && _.attendance.includes(payload.person)))
  //   )
  // },

  async beforeRouteLeave(context, {
    to,
    from,
    next
  }) {
    if (context.rootGetters.readOnly) {
      next()
    } else if (await actions['pass dirty?'](context)) {
      next()
    } else {
      next(false)
    }
  },

  // Helpers, don't dispatch them
  'valid?': function (context) {
    return context.dispatch('valid', {
      module: 'meeting2'
    }, {
      root: true
    })
  },
  'pass dirty?': function (context, payload) {
    if (context.rootGetters.readOnly) return 'no'
    return context.dispatch('dirty', {
      dirty: context.state.dirty,
      module: 'meeting2',
      caller: actions,
      saver: () => {
        const params = payload || {}
        params.keepEditing = true
        actions.save(context, params)
      }
    }, {
      root: true
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
